import { useContext } from "react";
import CloseIcon from "assets/icons/close.svg?react";
import ModalLayout, { DockPosition } from "components/ModalLayout";
import ModalsManagerContext, { InvoiceRegistryModalOptions } from "contexts/ModalsManager";
import InvoiceRegistryForm from "components/CreateRegistryEntryModal/InvoiceRegistryForm";
import BookingSlide from "./BookingSlide";
import styles from "components/CreateRegistryEntryModal/styles.module.scss";

const CreateInvoiceRegistryModal = () => {
  const { setModals, modals, options } = useContext(ModalsManagerContext);

  const preloadedFile =
    options instanceof InvoiceRegistryModalOptions && options.file
      ? { blob: options.file, fileName: options.fileName ?? "dokument.pdf" }
      : null;

  const accountingMode =
    options instanceof InvoiceRegistryModalOptions && !!options.accountingMode;
  const prefill =
    options instanceof InvoiceRegistryModalOptions ? options.prefill : undefined;
  const invoice =
    options instanceof InvoiceRegistryModalOptions ? options.invoice : undefined;
  const onBookNext =
    options instanceof InvoiceRegistryModalOptions ? options.onBookNext : undefined;
  const onBooked =
    options instanceof InvoiceRegistryModalOptions ? options.onBooked : undefined;

  const handleClose = () => {
    setModals({ ...modals, createInvoiceRegistryEntry: false });
  };

  // Tryb „Księgowanie" z pełnoekranowym podglądem PDF (slajd od prawej + PDF po lewej)
  if (accountingMode && invoice) {
    return (
      <BookingSlide
        invoice={invoice}
        prefill={prefill}
        onClose={handleClose}
        onBookNext={onBookNext}
        onBooked={onBooked}
      />
    );
  }

  return (
    <ModalLayout
      name="createInvoiceRegistryEntry"
      dock={DockPosition.DISABLED}
      off={true}
      customX={8}
      customY={0}
      ignore
      isAnimation
      fullHeight={true}
    >
      <div className={styles.wrapper}>
        <div className={styles.title}>
          Faktura/Rachunek
          <CloseIcon className={styles.closeIcon} onClick={handleClose} />
        </div>
        <div className={styles.content}>
          <InvoiceRegistryForm
            onClose={handleClose}
            preloadedFile={preloadedFile}
            hideFileSection={accountingMode}
            prefill={prefill}
          />
        </div>
      </div>
    </ModalLayout>
  );
};

export default CreateInvoiceRegistryModal;
